import { Link } from "react-router-dom";
import { ArrowUpRight, Sparkles } from "lucide-react";
import { TID } from "../../lib/testIds";

export function CalculatorCard({ calc, featured = false }) {
  const isLive = calc.status === "live";
  return (
    <Link
      to={`/calculators/${calc.slug}`}
      data-testid={
        featured ? TID.featuredCalculatorCard(calc.slug) : TID.calcCard(calc.slug)
      }
      className="group flex h-full flex-col rounded-2xl border border-slate-200 bg-white p-6 transition-all duration-200 hover:-translate-y-[2px] hover:border-emerald-300 hover:shadow-lg sm:p-7"
    >
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-center gap-2">
          <span
            className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wider ${
              isLive
                ? "bg-emerald-100 text-emerald-800"
                : "bg-slate-100 text-slate-600"
            }`}
          >
            {isLive ? (
              <>
                <Sparkles className="h-3 w-3" /> Live
              </>
            ) : (
              "Coming soon"
            )}
          </span>
          <span className="text-[10px] font-semibold uppercase tracking-wider text-slate-600">
            {calc.category.replace("-", " ")}
          </span>
        </div>
        <ArrowUpRight className="h-5 w-5 text-slate-300 transition-colors group-hover:text-emerald-600" />
      </div>
      <h3 className="mt-4 text-xl font-bold tracking-tight text-slate-900">
        {calc.name}
      </h3>
      <p className="mt-2 flex-1 text-sm text-slate-600">{calc.summary}</p>
      <span className="mt-5 inline-flex items-center text-sm font-medium text-emerald-700">
        {isLive ? "Open calculator" : "View details"} →
      </span>
    </Link>
  );
}
